<template>
  <div class="app-single-top-up-voucher-wrapper">
    <slot name="txtBefore"></slot>
    <div v-if="getVoucherView === 'topUpVoucherSuccess'">
      <dyn-slot :slot-data="slotData">
        <slot name="successMessage">
          <div class="success-message-voucher col-12">Dein FYVE Guthaben Konto wurde mit  {{slotData.amount}} EUR Guthaben aufgeladen.</div>
        </slot>
      </dyn-slot>
    </div>
    <voucher-input :next-step="'topUpVoucherSuccess'" :placeholder="placeholder"
    >
      <template v-for="slot in possibleChildSlotsFor('VoucherInput')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </voucher-input>
  </div>
</template>
<script>
import VoucherInput from '@/components/process/generic/TopUp/Voucher/fyve/Input.vue'
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'
import { mapGetters, mapMutations } from 'vuex'
import { price } from '../../../../../../mixins/price'

export default {
  name: 'SingleTopUpVoucherWrapper',
  props: {
    placeholder: {
      type: String,
      default: 'Aufladecode'
    }
  },
  computed: {
    ...mapGetters('topUp', [
      'getVoucherView',
      'getVoucherAmount'
    ]),
    slotData: function () {
      return this.formatedAmount
    },
    formatedAmount () {
      return {
        amount: price(this.getVoucherAmount) || 0
      }
    }
  },
  methods: {
    ...mapMutations('topUp', [
      'setVoucherView'
    ])
  },
  created () {
    this.setVoucherView('input')
  },
  components: { VoucherInput },
  mixins: [
    transaction('topupVoucher'),
    slotProxy(),
    price()
  ]
}
</script>
